module.exports = __webpack_public_path__ + "img/Tier 1 Alternative 3.7a9163fb.jpg";